import React, { useEffect, useState } from "react"
import View from "../View"
import firebase from "gatsby-plugin-firebase"

const RecoverEmail = (props) => {
  const { actionCode, continueUrl } = props
  const [ loading, setLoading ] = useState(true)
  const [ email, setEmail ] = useState(null)
  const [ submitting, setSubmitting ] = useState(false)
  const [ complete, setComplete ] = useState(false)

  useEffect(() => {
    firebase.auth().checkActionCode(actionCode).then(info => {
      const email = info["data"]["email"]
      setEmail(email)
      setLoading(false)
    }).catch(e => {
      console.log(e)
      setLoading(false)
    })
  }, [actionCode])

  const applyActionCode = () => {
    setSubmitting(true)
    firebase.auth().applyActionCode(actionCode).then(() => {
      firebase.auth().sendPasswordResetEmail(email).then(() => {
        setSubmitting(false)
        if (continueUrl) {
          setComplete(true)
          window.location.replace(continueUrl)
        } else {
          setComplete(true)
        }
      }).catch(e => {
        console.log(e)
        setSubmitting(false)
        alert("パスワード確認メール送信に失敗しました。\n管理者へご連絡ください。")
      })
    }).catch(e => {
      console.log(e)
      setSubmitting(false)
      alert("エラーが発生しました。\n時間を空けて再度実施していただくか、管理者へご連絡ください。")
    })
  }

  const renderLoading = () => {
    return (
      <View title={"Now loading..."}>
      </View>
    )
  }

  const renderInputForm = () => {
    let retVal = null

    if (email) {
      if (complete) {
        retVal = (
          <View title={`処理完了`}>
            <p class="text-base font-light leading-relaxed mt-6 mb-4 text-gray-600">
              メールアドレスの変更を取り消しました。
            </p>
          </View>
        )
      } else {
        retVal = (
          <View title={`メールアドレス変更の取り消し`}>
            <p class="text-base font-light leading-relaxed mt-6 mb-4 text-gray-600">
              メールアドレスの変更を取り消すことが可能です。<br />
              メールアドレスの変更を元に戻す場合は下記のボタンを押下してください。
            </p>
            <button type={"button"} onClick={applyActionCode}
                    className={"bg-blue-500 hover:bg-blue-400 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline float-right"}>
              {submitting ? "送信中..." : "変更を取り消す"}
            </button>
          </View>
        )
      }
    } else {
      retVal = (
        <View title={"ERROR"}>
          <p className="text-base font-light leading-relaxed mt-6 mb-4 text-gray-600">
            エラーが発生しました。<br/>
            時間を空けて再度実施してください。
          </p>
        </View>
      )
    }

    return retVal
  }


  return loading ? renderLoading() : renderInputForm()
}

export default RecoverEmail
